/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Submitticketsize_Modal_Mininputmustbegreaterthanzero9Inputs */

const en_coinvestments_submitticketsize_modal_mininputmustbegreaterthanzero9 = /** @type {(inputs: Coinvestments_Submitticketsize_Modal_Mininputmustbegreaterthanzero9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum must be greater than 0`)
};

/**
* | output |
* | --- |
* | "Minimum must be greater than 0" |
*
* @param {Coinvestments_Submitticketsize_Modal_Mininputmustbegreaterthanzero9Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_submitticketsize_modal_mininputmustbegreaterthanzero9 = /** @type {((inputs?: Coinvestments_Submitticketsize_Modal_Mininputmustbegreaterthanzero9Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Submitticketsize_Modal_Mininputmustbegreaterthanzero9Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_submitticketsize_modal_mininputmustbegreaterthanzero9(inputs)
});
export { coinvestments_submitticketsize_modal_mininputmustbegreaterthanzero9 as "coInvestments_submitTicketSize_modal_minInputMustBeGreaterThanZero" }